import React from 'react';
import {
	StyledEngineProvider,
	Theme,
	ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import { GlobalStyle } from '../ApplicationWrapper.styles';
import WeaveThemeProvider from './WeaveContext/WeaveThemeProvider';
import { createGenerateClassName } from '@mui/styles';
import { useWeaveThemeContext } from './WeaveContext';
import useDefaultTheme from './themes/useDefaultTheme';
import { innovyzeTheme } from '../../../hocs/ApplicationWrapper/theme/themes/innovyzeTheme';
import StylesProvider from '@mui/styles/StylesProvider';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

type MaterialProvidersProps = {
	children: React.ReactNode | React.ReactNode[] | string;
	theme?: Theme;
};

interface ThemeStylesProviderProps {
	children: React.ReactNode | React.ReactNode[] | string;
	theme?: Theme;
}

//Material UI and Styled Components Providers
const MaterialProviders = ({ children, theme }: MaterialProvidersProps) => {
	const generateClassName = createGenerateClassName({
		productionPrefix: 'inno',
	});

	const { weaveThemeConsumer, displayThemePicker } = useWeaveThemeContext();
	const resolvedRoles = weaveThemeConsumer?.resolvedRoles;
	const metadata = weaveThemeConsumer?.metadata;

	let selectedTheme = theme ?? innovyzeTheme;
	const weaveTheme = useDefaultTheme({
		weave: { resolvedRoles, metadata },
	});
	//if the flag to select a theme on picker is not set, use the legacy theme
	if (displayThemePicker && weaveTheme) {
		selectedTheme = weaveTheme;
	}

	return (
		<StylesProvider injectFirst generateClassName={generateClassName}>
			<StyledEngineProvider injectFirst>
				<MuiThemeProvider theme={selectedTheme}>
					<StyledComponentsThemeProvider theme={selectedTheme}>
						{children}
					</StyledComponentsThemeProvider>
				</MuiThemeProvider>
			</StyledEngineProvider>
		</StylesProvider>
	);
};

export const ThemeStylesProvider = ({
	children,
	theme,
}: ThemeStylesProviderProps) => {
	return (
		<WeaveThemeProvider>
			<MaterialProviders theme={theme}>
				<GlobalStyle />
				{children}
			</MaterialProviders>
		</WeaveThemeProvider>
	);
};
